import { Anchor, Group, Stack, Text } from '@mantine/core';
import { ManualTriggerInput } from '@/types/automationSteps.ts';

type props = {
  trigger: ManualTriggerInput;
  actionLabel?: string;
  onActionClick?: () => void;
};

const ManualTriggerInputHeader = ({ trigger, actionLabel, onActionClick }: props) => {
  const label = trigger.name || trigger.output_id;
  const description = trigger.description.trim();

  return (
    <Group justify={'space-between'} align={'flex-start'} wrap={'nowrap'}>
      <Stack gap={2} style={{ flex: 1, minWidth: 0 }}>
        <Text mb={description ? 0 : '7px'} fw={500} size={'13px'} c={'#0f172a'}>
          {label}
          {trigger.is_required && <span style={{ color: 'var(--mantine-color-error)' }}> *</span>}
        </Text>
        {description && (
          <Text mb={'7px'} size={'12px'} c={'dimmed'} style={{ lineHeight: 1.35 }}>
            {description}
          </Text>
        )}
      </Stack>
      {actionLabel && onActionClick && (
        <Anchor
          onClick={onActionClick}
          size={'11px'}
          c="brandBlue.6"
          mb={'4px'}
          style={{ flexShrink: 0, textAlign: 'right' }}
        >
          {actionLabel}
        </Anchor>
      )}
    </Group>
  );
};

export default ManualTriggerInputHeader;
